export default [
    {
        text: 'ID',
        value: 'id',
    },
    {
        text: 'nombre tag',
        value: 'tag',
    },
    {
        text: 'descripción',
        value: 'description',
    },
]
